/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateQueryRequest } from '../../models/create-query-request';
import { QueryDto } from '../../models/query-dto';

export interface QueriesPost$Plain$Params {
      body?: CreateQueryRequest
}

export function queriesPost$Plain(http: HttpClient, rootUrl: string, params?: QueriesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
  const rb = new RequestBuilder(rootUrl, queriesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryDto>;
    })
  );
}

queriesPost$Plain.PATH = '/queries';
